import { SVGProps } from 'react'

import { IconTemplate } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplate'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgInfo = (props: SVGProps<SVGSVGElement> & CustomIconProps) => (
	<IconTemplate {...props}>
		<path
			d="M12 15.2V11M12 8.8H12.008M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
			stroke="#9DBEFF"
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</IconTemplate>
)
